import mitt from 'mitt';

export const CURRENT_COUNTRY_CHANGED = 'currentCountryChanged';
export const CURRENT_USER_IS_LOGGED = 'currentUserIsLogged';
export const COUNTRY_PROPOSITION_SHOULD_EXPAND = 'countryPropositionShouldExpand';

export const PRODUCT_PRICE_UPDATED = 'product:priceUpdated';

export const PRODUCT_ADDED_TO_CART = 'tracking:productAddedToCart';
export const PRODUCT_FAVOURITED = 'tracking:productFavourited';
export const PRODUCT_UNFAVOURITED = 'tracking:productUnfavourited';
export const PRODUCT_VIEWED = 'tracking:productViewed';
export const MODEL_VIEWED = 'tracking:modelViewed';
export const CHECKOUT_STARTED = 'tracking:checkoutStarted';
export const PURCHASE_COMPLETED = 'tracking:purchaseCompleted';
export const USER_REGISTERED = 'tracking:userRegistered';
export const BTQ_APPOINTMENT_BOOKED = 'tracking:btqAppointmentBooked';
export const CONTACT_FORM_SUBMITTED = 'tracking:contactFormSubmitted';
export const NEWSLETTER_SUBSCRIBED = 'tracking:newsletterSubscribed';
export const CONTENT_VIEWED = 'tracking:contentViewed';
export const LIVECHAT_OPENED = 'livechat:opened';
export const CART_RESTARTED = 'cart:restarted';

export const emitter = mitt();
